import {
  Component,
  ViewEncapsulation,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';

import { findIndex } from 'lodash';

import * as fromStep from './steps.interface';
import { StepComponent } from './step.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./step.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class StepsComponent implements AfterContentInit {
  @Output() onResetStepsCallback = new EventEmitter<any>();
  @Output() onSaveStepsCallback = new EventEmitter<any>();
  @ContentChildren(StepComponent) steps: QueryList<StepComponent>;

  constructor() {}

  ngAfterContentInit() {
    const activeTabs = this.steps.filter((step) => step.active);

    if (activeTabs.length === 0) {
      this.selectStep(this.steps.first);
    }
  }

  nextStep() {
    const activeStepIndex = findIndex(this.steps.toArray(), function (step) {
      return step.active;
    });

    this.steps.toArray().forEach((step) => (step.active = false));
    this.steps.toArray()[activeStepIndex + 1].active = true;
  }

  onResetSteps() {
    this.onResetStepsCallback.emit();
  }

  selectStep(step) {
    this.steps.toArray().forEach((st) => (st.active = false));
    step.active = true;
  }

  onSaveCallback() {
    this.onSaveStepsCallback.emit();
  }
}
